import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
export const getHeaderConfig = [
  {
    label: "Name",
    id: "name",
  },
  {
    label: "Created By",
    id: "creatorName",
  },
  {
    label: "Created At",
    id: "createdAt",
    render: (data) => {
      return <div>{moment(data.createdAt).format("DD-MM-YYYY")}</div>;
    },
  },
  {
    label: "Actions",
    id: "actions",
    render: (data, onClick) => {
      return (
        <>
          <EditIcon
            onClick={() => onClick(data, "EDIT")}
            style={{ cursor: "pointer" }}
          />
          <DeleteIcon
            onClick={() => onClick(data, "DELETE")}
            color="error"
            style={{ cursor: "pointer" }}
          />
        </>
      );
    },
  },
];
